// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"18d217fb","695":"18d217fb"}[chunkId] + ".chunk.css";
};